import { Box, Button, Typography, makeStyles } from "@material-ui/core";
import { Link, useTranslate } from "react-admin";
import React, { useEffect, useRef, useState } from "react";

import ActionBar from "../../../components/ActionBar";
import BarChart from "./Dashboard-Component/BarChart";
import CardChart from "./Dashboard-Component/CardChart";
import DrawerComponent from "./Dashboard-Component/DrawerComponent";
import FilterList from "../../../components/FilterList";
import LineChart from "./Dashboard-Component/LineChart";
import LoyaltyComponent from "./Dashboard-Component/LoyaltyComponent";
import PaymentComponent from "./Dashboard-Component/PaymentComponent";
import PermissionChecker from "../../../components/PermissionChecker";
import SFBreadcrumbs from "../../../components/SfBreadcrumbs";
import SimpleLayoutContainer from "../../../components/SimpleLayoutContainer";
import StatisticComponent from "./Dashboard-Component/StatisticComponent";
import TierTriangleChart from "./Dashboard-Component/TierTriangleChart";
import Top5ProductsComponent from "./Dashboard-Component/Top5ProductsComponent";
import moment from "moment";
import { useAuthenticated } from "ra-core";
import { useReactToPrint } from "react-to-print";
import useStatNewSubs from "../../../hooks/useStatNewSubs";
import useStatRevenue from "../../../hooks/useStatRevenue";
import useStatTotalTrans from "../../../hooks/useStatTotalTrans";

//DrawerComponent

//import useSFSessionTimeout from "../../../hooks/useSFSessionTimeout";
const dateFormat = require("dateformat");

//const dateFormat = require("dateformat");

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    //justifyContent: "space-evenly ",
  },
  marginBox: {
    marginTop: 45,
    marginLeft: 23,
  },
  marginBox2: {
    marginTop: 40,
    marginLeft: 12,
  },
  verticalSpace: {
    height: "12px",
  },
  FilterAction: {
    display: "flex",
    justifyContent: "flex-end",
    textAlign: "right",
    marginTop: 10,
  },
  main: {
    display: "flex",
    flexDirection: "column",
  },
  Action: {
    width: "50%",
    display: "flex",
    justifyContent: "flex-end",
    marginRight: 36,
    marginTop: 35,
  },
}));

let filter = [
  {
    filterName: "All",
    selected: false,
  },
  {
    filterName: "Day",
    selected: false,
  },
  {
    filterName: "Month",
    selected: false,
  },
  {
    filterName: "Year",
    selected: false,
  },
  {
    filterName: "Custom Date",
    selected: false,
  },
];

const ComponentToPrint = React.forwardRef(
  (
    {
      filter,
      handleFilterType,
      handlePrint,
      revenue_data,
      periodType,
      fromDate,
      toDate,
      customer_data,
      fromDateChart,
    },
    ref
  ) => {
    const classes = useStyles();

    return (
      <SimpleLayoutContainer>
        <Box ref={ref} style={{ backgroundColor: "#f4f4f4" }}>
          <Box className={classes.main}>
            <Box className={classes.FilterAction}>
              <Box style={{ width: "50%", display: "flex", marginLeft: 5 }}>
                <SFBreadcrumbs path="Dashboard" lower />
              </Box>
              <Box className={classes.Action}>
                <FilterList
                  filterData={filter}
                  onChange={(filterName, value) => {
                    if (filterName === "") filterName = "Day";
                    handleFilterType(
                      filterName,
                      value.startDate,
                      value.endDate
                    );
                  }}
                />
                <ActionBar handlePrint={handlePrint} />
              </Box>
            </Box>
            <Box>
              <DrawerComponent />
            </Box>
            <Box className={classes.container}>
              <Box className={classes.marginBox}>
                <CardChart
                  data={revenue_data}
                  chart={
                    <BarChart
                      periodType={periodType}
                      fromDate={fromDateChart}
                      toDate={toDate}
                    />
                  }
                />
                <Box className={classes.verticalSpace} />
                <Box />
                {/* <CardChart
                  data={customer_data}
                  chart={
                    <LineChart
                      periodType={periodType}
                      fromDate={fromDateChart}
                      toDate={toDate}
                    />
                  }
                /> */}

                <Box className={classes.verticalSpace} />
                <Box />
                {/* <TierTriangleChart /> */}
              </Box>
              <Box className={classes.marginBox2}>
                {/* <StatisticComponent
                  periodType={periodType}
                  fromDate={fromDate}
                  toDate={toDate}
                /> */}
                <Box />
                <Top5ProductsComponent
                  periodType={periodType}
                  fromDate={fromDate}
                  toDate={toDate}
                />
                <PaymentComponent
                  periodType={periodType}
                  fromDate={fromDate}
                  toDate={toDate}
                />
                <LoyaltyComponent
                  periodType={periodType}
                  fromDate={fromDate}
                  toDate={toDate}
                />
              </Box>
            </Box>
            <Link to="/Insight"> Insight </Link>
          </Box>
        </Box>
        <PermissionChecker code="Page.Merchant.Business_Insight" />
      </SimpleLayoutContainer>
    );
  }
);

function BusinessInsightDashboard() {
  useAuthenticated();
  const componentRef = useRef();
  const translate = useTranslate();
  let _toDate = new Date();
  let formattedToDate = dateFormat(_toDate, "yyyy-mm-dd");
  const [periodType, setPeriodType] = useState("Day");
  const [fromDate, setFromDate] = useState(formattedToDate);
  const [toDate, setTodate] = useState(formattedToDate);
  const [fromDateChart, setFromDateChart] = useState(
    moment(_toDate).subtract(6, "days").format("YYYY-MM-DD")
  );
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    filter = filter.map((f) => ({ ...f, selected: false }));
    return () => {
      return (filter = filter.map((f) => ({ ...f, selected: false })));
    };
  }, []);
  //const [showTimeout] = useSFSessionTimeout();
  const handleFilterType = (newvalue, customDateFromDate, customDateToDate) => {
    if (!newvalue) {
      return;
    }

    let days = 6; // Days you want to subtract
    let _toDate = new Date();
    let formattedToDate = dateFormat(_toDate, "yyyy-mm-dd");

    if (newvalue === "Day") {
      setPeriodType("Day");
      const fromDateTypeDay = moment(_toDate)
        .subtract(days, "days")
        .format("YYYY-MM-DD");
      setFromDateChart(fromDateTypeDay);
      setFromDate(formattedToDate);
      setTodate(formattedToDate);
    } else if (newvalue === "Month") {
      setPeriodType("Month");
      const fromMonth = moment(_toDate)
        .subtract(days, "months")
        .format("YYYY-MM-DD");

      setFromDateChart(fromMonth);
      setFromDate(moment(_toDate).startOf("month").format("YYYY-MM-DD"));
      setTodate(formattedToDate);
    } else if (newvalue === "Year") {
      setPeriodType("Year");
      const fromYears = moment(_toDate)
        .subtract(days, "years")
        .format("YYYY-MM-DD");
      setFromDateChart(fromYears);
      setFromDate(moment(_toDate).startOf("year").format("YYYY-MM-DD"));
      setTodate(formattedToDate);
    } else if (newvalue === "All") {
      setPeriodType("All");
      setFromDate("2000-01-01");
      setTodate(formattedToDate);
    } else {
      if (!customDateFromDate || !customDateToDate) {
        return;
      }
      let customDateFormattedFromDate = dateFormat(
        customDateFromDate,
        "yyyy-mm-dd"
      );
      let customDateFormattedToDate = dateFormat(
        customDateToDate,
        "yyyy-mm-dd"
      );
      setPeriodType("Day");
      setFromDateChart(customDateFormattedFromDate);
      setFromDate(customDateFormattedFromDate);
      setTodate(customDateFormattedToDate);
    }
  };

  const {
    statRevenue,
    loading: statRevenueLoading,
    error: statRevenueError,
  } = useStatRevenue(periodType, fromDate, toDate);

  const {
    newSubs,
    loading: newSubsLoading,
    error: newSubsError,
  } = useStatNewSubs(periodType, fromDate, toDate);
  const {
    totalTrans,
    loading: totalTransLoading,
    error: totalTransError,
  } = useStatTotalTrans(periodType, fromDate, toDate);
  if (newSubsLoading || totalTransLoading || statRevenueLoading)
    return <Typography>Loading ...</Typography>;
  if (newSubsError || totalTransError || statRevenueError) {
    return (
      <Typography>
        Something went wrong, You may need to re-login again...
      </Typography>
    );
  }

  let totalPoint = statRevenue?.payload?.total_revenue?.reduce(function (
    total,
    currentValue
  ) {
    return total + currentValue.value;
  },
  0);
  let walkInDatas = [];
  let member_sum = 0;
  let walkIn_sum = 0;
  member_sum = newSubs?.reduce(
    (totalNewSubs, currentNewSubs) => totalNewSubs + currentNewSubs.value,
    0
  );
  totalTrans?.total_trans?.forEach((element) => {
    if (!element.segment || !element.segment.customerType) {
      return;
    }
    const guest = Object.values(element.segment.customerType).find(
      (value) => value.name === "Guest"
    );
    walkInDatas.push(guest.value);
  });

  walkIn_sum = walkInDatas.reduce(
    (totalWalkIn, currentWalkin) => totalWalkIn + currentWalkin,
    0
  );
  let totalCustomer = member_sum + walkIn_sum;

  let revenue_data = {
    name: translate("ra.text.bi.revenue"),
    totalName: translate("ra.text.bi.totalRevenue"),
    totalAmount: totalPoint,
  };
  let customer_data = {
    name: translate("ra.text.bi.customer"),
    totalName: translate("ra.text.bi.totalCustomer"),
    totalAmount: totalCustomer,
  };

  return (
    <ComponentToPrint
      ref={componentRef}
      filter={filter}
      handleFilterType={handleFilterType}
      handlePrint={handlePrint}
      revenue_data={revenue_data}
      periodType={periodType}
      fromDate={fromDate}
      toDate={toDate}
      customer_data={customer_data}
      fromDateChart={fromDateChart}
    />
  );
}

export default BusinessInsightDashboard;
